import React from 'react';
import Hero from './components/it-policy/Hero';
import Main from './components/it-policy/Main';

const ITPolicy = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ITPolicy;